<template>
    <k-panel>
        <k-panel-header>Bond description</k-panel-header>
        <div class="grid grid-cols-2 gap-1">
            <div>
                <k-panel-property>
                    <div slot="left">
                        Interest rate
                    </div>
                    <div slot="right">{{ tranche.interestRate | numeralFormat('0.00') }}%</div>
                </k-panel-property>
                <k-panel-property>
                    <div slot="left">
                        Maturity date
                    </div>
                    <div slot="right">{{ tranche.maturityDate | dateFormat }}</div>
                </k-panel-property>
                <k-panel-property>
                    <div slot="left">
                        Interest Frequency
                    </div>
                    <div slot="right"> {{ tranche.paymentPeriod }} </div>
                </k-panel-property>
                <k-panel-property>
                    <div slot="left">
                        Nominal value
                    </div>
                    <div slot="right">{{ tranche.nominalValue | currencyFormat(tranche.currencySymbol) }}</div>
                </k-panel-property>
                <k-panel-property>
                    <div slot="left">
                        Next Capital call
                    </div>
                    <div slot="right" v-if="tranche.nextCapitalCallDate"> {{
                            tranche.nextCapitalCallDate | dateFormat
                        }}
                    </div>
                    <div slot="right" v-else> -</div>
                </k-panel-property>
                <k-panel-property>
                    <div slot="left">
                        Interest commencement date
                    </div>
                    <div slot="right"> {{ tranche.interestCommencementDate | dateFormat }}</div>
                </k-panel-property>
                <k-panel-property v-if="tranche.discountedPrice">
                    <div slot="left">
                        Discounted price
                    </div>
                    <div slot="right"> {{ tranche.discountedPrice | currencyFormat(tranche.currencySymbol) }}</div>
                </k-panel-property>
            </div>
            <div class="text-right sm:text-left">
                <k-panel-property>
                    <div slot="left">
                        Currency
                    </div>
                    <div slot="right">{{ tranche.currencyCode }}
                    </div>
                </k-panel-property>
                <k-panel-property v-if="tranche.term">
                    <div slot="left">
                        Next Interest Payment
                    </div>
                    <div slot="right" v-if="tranche.nextPaymentDate">
                        {{ tranche.nextPaymentDate | dateFormat }}
                    </div>
                    <div slot="right" v-else>
                        -
                    </div>
                </k-panel-property>
                <k-panel-property v-if="tranche.collateral">
                    <div slot="left">
                        Collateral
                    </div>
                    <div slot="right">
                        <div v-for="collateral in tranche.collateral" :key="collateral">
                            {{ collateral }}&nbsp;
                        </div>
                    </div>
                </k-panel-property>
                <k-panel-property>
                    <div slot="left">
                        Available to invest
                    </div>
                    <div slot="right">{{ tranche.currencySymbol }}{{
                            tranche.principalAvailable | numeralFormat('0,0.')
                        }}
                    </div>
                </k-panel-property>
                <k-panel-property>
                    <div slot="left">
                        Tranche number
                    </div>
                    <div slot="right">{{ tranche.trancheNumber }}</div>
                </k-panel-property>
                <k-panel-property>
                    <div slot="left">
                        Status
                    </div>
                    <div slot="right">{{ tranche.status }}</div>
                </k-panel-property>
                <k-panel-property v-if="tranche.minimalSettlementAmount">
                  <div slot="left">
                  Minimal Settlement Amount
                  <a-icon class="info-tooltip" type="info-circle"
                 v-tooltip="'Your investment will be refunded if the total subscription amount doesn\'t reach the minimum settlement amount at settlement time.'"/>
                  </div>
                 <div slot="right">{{ tranche.minimalSettlementAmount | currencyFormat(tranche.currencySymbol) }}</div>
                </k-panel-property>
            </div>
        </div>
    </k-panel>
</template>

<script>
export default {
    props: {
        tranche: {
            type: Object,
            required: true
        },
        borrower: {
            type: Object,
            required: true
        }
    }
};
</script>


<style scoped>
.icon {
    height: 12px;
    width: 12px;
}
</style>
